import { ButtonType, IconButton } from '@ardoq/button';
import { IconName, IconSize, UrlIcon } from '@ardoq/icons';
import { ButtonWithDropdown } from '@ardoq/dropdown-menu';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { isTruthy } from '@ardoq/common-helpers';

export type CopyEntityURLButtonCommands = {
  copyDiscoverEntityUrl: VoidFunction;
  copyArdoqEntityUrl: VoidFunction;
};

export type CopyEntityURLButtonLabels = {
  copyArdoqEntityUrl: string;
  copyDiscoverEntityUrl: string;
  tooltipText: string;
};

export type CopyEntityURLButtonProps = {
  hasNewDiscoverCoreNavigation: boolean;
  copyDiscoverEntityUrl: CopyEntityURLButtonCommands['copyDiscoverEntityUrl'];
  labels: CopyEntityURLButtonLabels;
} & (
  | { hasCopyArdoqURLOption: false } // should be false only in discover, should be removed after discover becomes part of core codebase
  | {
      hasCopyArdoqURLOption: true;
      copyArdoqEntityUrl: CopyEntityURLButtonCommands['copyArdoqEntityUrl'];
    }
);

export const CopyEntityURLButton = (props: CopyEntityURLButtonProps) => {
  const { hasCopyArdoqURLOption, hasNewDiscoverCoreNavigation, labels } = props;
  if (hasNewDiscoverCoreNavigation && hasCopyArdoqURLOption) {
    return (
      <IconButton
        iconName={IconName.URL}
        buttonType={ButtonType.GHOST}
        label={labels.copyArdoqEntityUrl}
        onClick={props.copyArdoqEntityUrl}
      />
    );
  }

  return (
    <ButtonWithDropdown
      alignMenuTo="left"
      dropdownSize={DropdownSize.S}
      options={[
        hasCopyArdoqURLOption && {
          label: labels.copyArdoqEntityUrl,
          onClick: props.copyArdoqEntityUrl,
        },
        {
          label: labels.copyDiscoverEntityUrl,
          onClick: props.copyDiscoverEntityUrl,
        },
      ].filter(isTruthy)}
      data-tooltip-text={labels.tooltipText}
      hideChevron
      buttonType={ButtonType.GHOST}
    >
      <UrlIcon iconSize={IconSize.SMALL} />
    </ButtonWithDropdown>
  );
};
